var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg137260876063001733136031(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4432 16.335C18.8951 13.0635 17.3287 10.0484 14.9672 7.719C14.4502 7.216 14.1922 6.965 13.6212 6.733C13.0502 6.5 12.5592 6.5 11.5782 6.5H9.42219C8.44119 6.5 7.95019 6.5 7.37919 6.733C6.80919 6.965 6.54919 7.216 6.03319 7.719C3.67165 10.0484 2.10529 13.0635 1.55719 16.335C1.07019 19.273 3.78019 21.5 6.80819 21.5H14.1922C17.2212 21.5 19.9322 19.273 19.4422 16.335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75718 3.943C5.55018 3.643 5.25118 3.235 5.86918 3.143C6.50418 3.047 7.16318 3.481 7.80918 3.473C8.39218 3.464 8.68918 3.205 9.00918 2.835C9.34518 2.446 9.86518 1.5 10.5002 1.5C11.1352 1.5 11.6552 2.446 11.9912 2.835C12.3112 3.205 12.6082 3.465 13.1912 3.472C13.8372 3.482 14.4962 3.047 15.1312 3.142C15.7492 3.235 15.4502 3.642 15.2432 3.942L14.3112 5.301C13.9112 5.881 13.7122 6.171 13.2942 6.336C12.8762 6.501 12.3372 6.5 11.2582 6.5H9.74218C8.66218 6.5 8.12318 6.5 7.70618 6.336C7.28918 6.172 7.08918 5.88 6.68918 5.3L5.75718 3.943Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg137260876063001733136031);
export default __webpack_public_path__ + "static/media/137260876063001733136031.00491df9e2fc4fd8744c3cd7fec9d87e.svg";
export { ForwardRef as ReactComponent };